import { render, staticRenderFns } from "./PartnersCard.vue?vue&type=template&id=3b055341&scoped=true"
import script from "./PartnersCard.vue?vue&type=script&lang=js"
export * from "./PartnersCard.vue?vue&type=script&lang=js"
import style0 from "./PartnersCard.vue?vue&type=style&index=0&id=3b055341&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b055341",
  null
  
)

export default component.exports